<div class="filter-row">
  <div class="location-input">
    <label class="label-select" translate>components.homePage.where</label>
    <input
      matInput
      (keyup.enter)="chooseFirstOption()"
      type="text"
      class="form-control no-border search"
      placeholder="{{ 'components.homePage.exampleBarcelona' | translate }}"
      name="fieldName"
      ngDefaultControl
      autocomplete="off"
      [formControl]="selectedLocation"
      [matAutocomplete]="auto"
    />
    <div>
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option
          class="poppins"
          (onSelectionChange)="onSearchLocation(option)"
          *ngFor="let option of filteredOptions | async"
          [value]="option.description"
        >
          {{ option.description }} ({{ option.propertyCount }})
        </mat-option>
        <mat-option
          class="poppins"
          *ngIf="filter.length == 0 && selectedLocation.value"
          translate
        >
          No se encontraron resultados.
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="separator"></div>
  <div class="price-min-input">
    <label class="label-select" translate>components.homePage.price</label>
    <div
      style="display: flex; justify-content: flex-start; align-items: center"
    >
      <select
        class="form-control no-border clean-select"
        id="selectPriceMin"
        (change)="onchangePrecio($event.target, 'desde')"
        aria-label="Default select example"
        [style.width]="getWidth('price', 'min')"
      >
        <option disabled selected translate>components.homePage.min</option>
        <option
          *ngFor="let item of arrayPrecioDe"
          [selected]="item.selected"
          [disabled]="item.isDisabled"
          [value]="item.value"
          class="form-control"
        >
          <div>{{ item.name }}</div>
        </option>
      </select>
      <span style="margin: 0 5px">-</span>
      <select
        class="form-control no-border clean-select"
        id="selectPriceMax"
        (change)="onchangePrecio($event.target, 'hasta')"
        aria-label="Default select example"
        [style.width]="getWidth('price', 'max')"
      >
        <option disabled selected translate>components.homePage.max</option>
        <option
          *ngFor="let item of arrayPrecioa"
          [selected]="item.selected"
          [disabled]="item.isDisabled"
          [value]="item.value"
          class="form-control"
        >
          {{ item.name }}
        </option>
      </select>
    </div>
  </div>
  <div class="separator"></div>
  <div class="rent-input">
    <label class="label-select" translate>components.homePage.profitability</label>
    <select
      id="selectProfitMin"
      (change)="filterProfitability($event.target)"
      class="form-control no-border"
      aria-label="Default select example"
      [style.width]="getWidth('profitability', null)"
    >
      <option disabled selected translate>components.homePage.any</option>
      <option
        *ngFor="let item of arrayRentabilidad"
        [selected]="item.selected"
        class="form-control"
      >
        {{ item.name }}
      </option>
    </select>
  </div>
  <div class="search-btn">
    <button class="btn-inmueble" (click)="findPublication()">
      <span translate> components.homePage.search</span>
    </button>
  </div>
</div>
